import {Box} from '@mui/material'
import {DataGrid} from '@mui/x-data-grid'
import React, {useEffect, useState} from 'react'
import {dataColumn, timeColumn} from '../DataColumn'
import {useGetDetailApprovalInfoQuery, useGetMainApprovalInfoQuery} from '../../store/api/requestApi'
import {useParams} from 'react-router'
import {useSelector} from 'react-redux'
import {useLocation} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import moment from "moment";

export default function ApprovalInfoGrid({lineDisabled}) {
    const {t} = useTranslation('request')
    const {dataId} = useParams()
    const requestData = useSelector((state) => state.persistSlice.requestData)
    const selectedMaterialData = useSelector((state) => state.persistSlice.selectedMaterialData)

    const [id, setId] = useState(0)
    const url = useLocation().pathname
    const {data: requestMain} = useGetMainApprovalInfoQuery(id)
    const {data: requestDetail} = useGetDetailApprovalInfoQuery(id)
    const [tableData, setTableData] = useState([])

    // useEffect(() => {
    //   if (id === 0 && url === '/requests') {
    //     setTableData([])
    //   } else {
    //     setTableData(requestMain?.data)
    //   }
    // }, [id, requestMain, url])


    // useEffect(() => {
    //   if (requestDetail && url === `/requests/${dataId}`) {
    //     setTableData(requestDetail?.data)
    //   } else {
    //     setTableData([])
    //   }
    // }, [id, requestDetail, url, dataId])


    // useEffect(() => {
    //   switch (url) {
    //     case '/requests':
    //       setTableData(requestMain?.data)
    //       break;
    //     case `/requests/${dataId}`:
    //       setTableData(requestDetail?.data)
    //       break;
    //     default:
    //       setTableData([])
    //       break;
    //   }
    // }, [dataId, requestMain, requestDetail, url, id]);

    useEffect(() => {
        if (url === '/requests' && id !== 0) {
            setTableData(requestMain?.data)
        } else if (url === `/requests/${dataId}` && id !== 0) {
            setTableData(requestDetail?.data)
        } else {
            setTableData([])
        }
    }, [url, id, requestMain, requestDetail, dataId])


    useEffect(() => {
        switch (url) {
            case '/requests':
                if (requestData?.length > 1 || requestData?.length === 0) {
                    setId(0)
                } else {
                    setId(requestData[requestData.length - 1]?.requestMainId)
                }
                break;
            case `/requests/${dataId}`:
                if (selectedMaterialData?.length > 0) {
                    setId(selectedMaterialData[0]?.requestDetailId)
                } else {
                    setId(0)
                }
                break;
            default:
                break;
        }
    }, [dataId, requestData, selectedMaterialData, url]);

    // useEffect(() => {
    //   if (requestData?.length > 1 || requestData.length === 0) {
    //     setId(0)
    //   } else {
    //     setId(requestData[requestData.length - 1]?.requestMainId)
    //   }
    // }, [dataId, requestData])

    // useEffect(() => {
    //   if (dataId > 0) {
    //     setId(dataId)
    //   } else if (materialData?.length > 1 || materialData.length === 0) {
    //     setId(0)
    //   }
    // }, [dataId, materialData])

    const columnsMain = [
        dataColumn('lineNo', t('line_no'), 70),
        dataColumn('sequence', t('sequence'), 70),
        dataColumn('approvalStatusName', t('approvalStatus'), 100),
        dataColumn('approveStageDetailsName', t('approvalDetail'), 100),
        dataColumn('approvedBy', t('approvedBy'), 240),
        timeColumn('approveDate', t('approveDate'), 100, false, data => {
            return data?.row?.approveDate ? moment(data?.row?.approveDate).format('DD.MM.YYYY HH:mm') : null
        }),
        dataColumn('comment', t('comment'), 150),
    ]

    const columnsCard = [
        dataColumn('sequence', t('sequence'), 70),
        dataColumn('approvalStatusName', t('approvalStatus'), 100),
        dataColumn('approveStageDetailsName', t('approvalDetail'), 100),
        dataColumn('approvedBy', t('approvedBy'), 240),
        timeColumn('approveDate', t('approveDate'), 100, false, data => {
            return data?.row?.approveDate ? moment(data?.row?.approveDate).format('DD.MM.YYYY HH:mm') : null
        }),
    ]

    return (
        <div>
            <Box sx={{height: 212, width: 400}}>
                <DataGrid
                    rows={tableData || []}
                    columns={!lineDisabled ? columnsMain : columnsCard}
                    getRowId={(row) => row?.requestApprovalId}
                    hideFooter
                    rowHeight={30}
                />
            </Box>
        </div>
    )
}

